// pages/AccessErrorPage.jsx
import { useSearchParams, Link } from 'react-router-dom';

export default function AccessErrorPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');
  
  const errorMessages = {
    'token-not-found': {
      title: 'Link Invalid',
      message: 'Linkul de acces nu a fost găsit în sistem.',
      icon: '🔍'
    },
    'server-error': {
      title: 'Eroare Server',
      message: 'A apărut o eroare tehnică. Vă rugăm încercați din nou mai târziu.',
      icon: '⚠️'
    }
  };
  
  const error = errorMessages[reason] || errorMessages['server-error'];

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="text-6xl mb-4">{error.icon}</div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {error.title}
        </h1>
        
        <p className="text-gray-600 mb-6">
          {error.message}
        </p>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-sm text-blue-800">
          <p className="font-semibold mb-1">Aveți nevoie de ajutor?</p>
          <p>Contactați echipa de suport pentru asistență.</p>
        </div>
      </div>
    </div>
  );
}